import EGSCheckbox from '@/components/ui/library/EGS_Checkbox.vue';
import EGSColumn from '@/components/ui/library/EGS_Column.ts';
import EGSConfirmDialog from '@/components/ui/library/EGS_ConfirmDialog.vue';
import EGSDataTable from '@/components/ui/library/EGS_DataTable.vue';
import Dialog from '@/components/Dialog/EGS_Dialog.vue';
import EGSDivider from '@/components/ui/library/EGS_Divider.vue';
import EGSFieldset from '@/components/ui/library/EGS_Fieldset.vue';
import InputSwitch from '@/components/ToggleSwitch/ToggleSwitch.vue';
import InputText from '@/components/ui/inputs/EGS_Input.vue';
import EGSMenu from '@/components/ui/library/EGS_Menu.vue';
import Message from '@/components/Alert/EGS_Alert.vue';
import MultiSelect from '@/components/ui/inputs/MultiSelect/EGS_MultiSelect.vue';
import EGSPaginator from '@/components/ui/library/EGS_Paginator.vue';
import EGSPopover from '@/components/ui/library/EGS_Popover.vue';
import EGSRadioButton from '@/components/ui/library/EGS_RadioButton.vue';
import Select from '@/components/Dropdown/Dropdown.vue';
import EGSSkeleton from '@/components/ui/library/EGS_Skeleton.vue';
import Tab from '@/components/Tab/Tab.vue';
import Tag from '@/components/Chip/EGS_Chip.vue';
import EGSToast from '@/components/ui/library/EGS_Toast.vue';
import EGSToolbar from '@/components/ui/library/EGS_Toolbar.vue';
import Button from '@/components/Button/EGS_Button.vue';

const uiComponents = {
	Button,
	Dialog,
	Dropdown: Select,
	InputSwitch,
	InputText,
	Message,
	MultiSelect,
	Select,
	Tab,
	Tag,
	EGS_Checkbox: EGSCheckbox,
	EGS_Column: EGSColumn,
	EGS_ConfirmDialog: EGSConfirmDialog,
	EGS_DataTable: EGSDataTable,
	EGS_Divider: EGSDivider,
	EGS_Fieldset: EGSFieldset,
	EGS_Menu: EGSMenu,
	EGS_Paginator: EGSPaginator,
	EGS_Popover: EGSPopover,
	EGS_RadioButton: EGSRadioButton,
	EGS_Skeleton: EGSSkeleton,
	EGS_Toast: EGSToast,
	EGS_Toolbar: EGSToolbar
};

export function registerUiComponents(app) {
	for (const [name, component] of Object.entries(uiComponents)) app.component(name, component);
}

export { uiComponents };
